/* eslint-disable */
import connect from '../views/axios/axios.auth';
import numeral from 'numeral';

const utils = {
   getTypeDocumentName: (value) => {
     const document = {
       "VN": "VENTA NORMAL",
       "ND": "NOTA DE DEBITO",
       "NC": "NOTA DE CREDITO",
     }
     return document[value] || 'TIPO DE DOCUMENTO NO INDENTIFICADO';
   },
   onlyNumber: (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
   },
   obtenerValorPermiso: (permissionName, arr) => {
      const permission = arr.filter(val => val.config_extra.referencia_atributo === permissionName)[0];
      return permission ? permission.valor_permiso : false;
   },
   calculatePiesCubicos: (acho, largo, alto, formula) => {
    
    let parametros = {
      '@alto': alto,
      '@largo': largo,
      '@ancho': acho,
    }
  
    const param = Object.keys(parametros).join('|');
    let regex = new RegExp(param, 'gi');
    
    const convertFormula = formula.replace(regex, (matched) => (
      parametros[matched]
    ));
    
    let valor = eval(convertFormula);
    return numeral(valor).format('0.00');
  
   },
   formatMoney: (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  },
  enviarGuiaCorreo: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/guias/email`, {data}).then((response) => {
        resolve(response);
      })
    })
  },
  anularGuia: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/guias/anular`, {data}).then((response) => {
        resolve(response);
      })
    })
  },
  filterTable: (arr, searchKey) => {
    let resultValues = arr.filter(obj => 
      Object.keys(obj).some(
        key => typeof obj[key] === "string" && 
        obj[key].toLowerCase().includes(searchKey.toLowerCase()) 
    ));
    return resultValues;
  },
  formasPago: () => {
    return new Promise((resolve, reject) => {
      connect.get(`/utils/pagos`).then((response) => {
        resolve(response.data);
      })
    })
  },
  externos: () => {
    return new Promise((resolve, reject) => {
      connect.get(`/utils/externos`).then((response) => {
        resolve(response.data);
      })
    })
  },
  configExtra: (data, permiso) => {
    const operacion = data.filter((e) => e.config_extra.referencia_atributo === permiso)[0];
    return operacion.valor_permiso;
  },
  configCalendar: {
    locale: {
      sunday: 'Do',
      monday: 'Lu',
      tuesday: 'Ma',
      wednesday: 'Mi',
      thursday: 'Ju',
      friday: 'Vi',
      saturday: 'Sa',
      ok: 'Confirmar',
      today: 'Hoy',
      yesterday: 'Ayer',
      last7Days: 'Ultimos 7 días'
    }
  }
}

export default utils;